var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.858 27c-.367-.482-.517-1.06-.517-1.648 0-2.106 1.373-4.33 3.492-5.97.087-.068.176-.135.266-.201C5.071 19.739 2 23.099 2 25.594 2 26.524 2.637 27 4.423 27zM12.323 8.056A4.911 4.911 0 0 0 11.581 8c-2.564 0-4.79 2.037-4.79 4.706 0 2.702 2.215 4.794 4.79 4.794a4.8 4.8 0 0 0 3.484-1.517c-1.855-1.21-3.111-3.298-3.111-5.728 0-.777.13-1.515.37-2.199z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.42 27h16.729C29.254 27 30 26.449 30 25.371c0-3.158-4.305-7.517-11.213-7.517-6.9 0-11.206 4.359-11.206 7.518 0 1.077.746 1.628 2.839 1.628z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.806 16c3 0 5.613-2.422 5.613-5.576C24.419 7.31 21.806 5 18.806 5c-3.004 0-5.612 2.359-5.612 5.45 0 3.128 2.595 5.55 5.612 5.55z",
    opacity: 0.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserUsers);
export default __webpack_public_path__ + "static/media/User_Users.1cfc51ee51858c6082da4493e3d28381.svg";
export { ForwardRef as ReactComponent };